export const TEMPLATE_PRICE: string = (150.0).toFixed(2);
